import { type InsuranceCorporateIdentity } from "../types";

export function PWCLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M325.479 303.794C313.124 305.828 306.74 314.942 306.74 331.12C306.74 347.299 315.156 358.172 328.06 358.172C334.032 358.172 339.592 356.137 351 350.557V363.753C337.162 370.131 329.145 372 318.052 372C305.972 372 297.543 368.742 290.596 361.801C287.122 358.252 284.396 354.042 282.577 349.419C280.759 344.795 279.887 339.854 280.012 334.887C280.012 311.629 297.117 296 322.226 296C338.933 296 350.341 303.615 350.341 314.763C350.341 321.966 345.042 326.859 337.038 326.859C332.92 326.859 329.708 325.773 325.356 323.326L325.479 303.794Z"
        fill="#1C1C1C"
      />
      <path
        d="M263.849 334.38C275.02 320.196 279 314.42 279 307.53C279 305.861 278.671 304.209 278.031 302.671C277.391 301.133 276.453 299.739 275.272 298.572C274.092 297.405 272.693 296.488 271.157 295.876C269.621 295.263 267.98 294.966 266.329 295.003C264.381 294.999 262.451 295.386 260.652 296.141C258.853 296.896 257.22 298.004 255.847 299.401V328.325L237.598 352.961V296.938H220.271L191.347 345.25V296.938H181.169L155 303.396V310.147L169.31 311.664V371H187.849L215.492 325.068V371H235.656L263.849 334.38Z"
        fill="#1C1C1C"
      />
      <path
        d="M100.177 393.399L112.185 396.142V403H65.0904V396.142L75.8703 393.399V311.732H64V304.682L92.8477 296H100.301V305.739C113.814 297.742 118.466 296.384 125.284 296.384C141.268 296.384 153 311.033 153 331.237C153 354.719 137.306 370.451 112.461 370.451C108.357 370.447 104.256 370.218 100.177 369.766V393.399ZM100.177 361.522C102.082 361.659 103.034 361.659 104.318 361.659C119.197 361.659 127.258 352.442 127.258 334.666C127.258 319.743 120.702 311.732 108.693 311.732C105.918 311.837 103.152 312.112 100.412 312.555V361.522H100.177Z"
        fill="#1C1C1C"
      />
      {/* Geometric shapes from PWC logo */}
      <path d="M450 200H432V236H450V200Z" fill="#EB5C99" />
      <path d="M395 124H381V146H395V124Z" fill="#F7B887" />
      <path d="M381 110H310V124H381V110Z" fill="#F2941F" />
      <path d="M310 200V124H381V145.967H310V200Z" fill="#ED6E17" />
      <path d="M432 146H395V200H432V146Z" fill="#FABA00" />
      <path d="M432 200H395V236H432V200Z" fill="#E8451C" />
      <path d="M395 146H381V200H395V146Z" fill="#F28A08" />
      <path d="M395 200H381V236H395V200Z" fill="#E53617" />
      <path d="M381 200H354.332V182.005H310V200V146H381V200Z" fill="#E8540F" />
      <path d="M381 200H354V236H381V200Z" fill="#E52612" />
      <path d="M354 182H310V200H354V182Z" fill="#C44017" />
      <path d="M354 200H310V236H354V200Z" fill="#C22417" />
      <path d="M310 236H238V254H310V236Z" fill="#C22417" />
    </svg>
  );
}

export const PWC: InsuranceCorporateIdentity = {
  id: "pwc",
  name: "PwC BKK",
  logo: PWCLogo,
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  wildcard: "pricewaterhousecoopers",
  type: "statutory",
};
